// import { { } } from "../lib/common/common-request-attr.model";

export class PointTypeRequestModel {
    id?: number;
    pointType: string;

    constructor(
        pointType: string,
        id?: number,
    ) {
        
        this.id = id;
        this.pointType = pointType;

    }
}
